import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { debounce } from 'lodash';
import { updateTileVisible } from "../utils";
export var Base = /*#__PURE__*/function () {
  function Base() {
    _classCallCheck(this, Base);

    _defineProperty(this, "initedTileset", false);

    _defineProperty(this, "viewchange", debounce(this.mapchange, 200));
  }

  _createClass(Base, [{
    key: "children",
    get: function get() {
      return this.tileLayerManager.children;
    }
  }, {
    key: "mapchange",
    value: function mapchange() {
      var _this$tilesetManager;

      var _this$getCurrentView = this.getCurrentView(),
          latLonBounds = _this$getCurrentView.latLonBounds,
          zoom = _this$getCurrentView.zoom;

      if (this.mapService.version === 'GAODE1.x') {
        var _this$parent$getLayer = this.parent.getLayerConfig(),
            visible = _this$parent$getLayer.visible;

        if (zoom < 3 && visible) {
          this.parent.updateLayerConfig({
            visible: false
          });
          this.layerService.reRender();
        } else if (zoom >= 3 && !visible) {
          this.parent.updateLayerConfig({
            visible: true
          });
          this.layerService.reRender();
        }
      }

      if (this.lastViewStates && this.lastViewStates.zoom === zoom && this.lastViewStates.latLonBounds.toString() === latLonBounds.toString()) {
        return;
      }

      this.lastViewStates = {
        zoom: zoom,
        latLonBounds: latLonBounds
      };
      (_this$tilesetManager = this.tilesetManager) === null || _this$tilesetManager === void 0 ? void 0 : _this$tilesetManager.throttleUpdate(zoom, latLonBounds);
    }
  }, {
    key: "getCurrentView",
    value: function getCurrentView() {
      var bounds = this.mapService.getBounds();
      var latLonBounds = [bounds[0][0], bounds[0][1], bounds[1][0], bounds[1][1]];
      var zoom = this.mapService.getZoom();
      return {
        latLonBounds: latLonBounds,
        zoom: zoom
      };
    }
  }, {
    key: "initTileSetManager",
    value: function initTileSetManager() {
      var _this$tilesetManager2;

      var source = this.parent.getSource();
      this.tilesetManager = source.tileset;

      if (!this.initedTileset) {
        this.bindTilesetEvent();
        this.initedTileset = true;
      }

      var _this$getCurrentView2 = this.getCurrentView(),
          latLonBounds = _this$getCurrentView2.latLonBounds,
          zoom = _this$getCurrentView2.zoom;

      (_this$tilesetManager2 = this.tilesetManager) === null || _this$tilesetManager2 === void 0 ? void 0 : _this$tilesetManager2.update(zoom, latLonBounds);
    }
  }, {
    key: "bindTilesetEvent",
    value: function bindTilesetEvent() {
      var _this = this;

      if (!this.tilesetManager) {
        return;
      } // 瓦片数据加载成功
      // eslint-disable-next-line @typescript-eslint/no-unused-vars


      this.tilesetManager.on('tile-loaded', function (tile) {// 将事件抛出，图层上可以监听使用
      }); // 瓦片数据从缓存删除或被执行重新加载

      this.tilesetManager.on('tile-unload', function (tile) {
        // 将事件抛出，图层上可以监听使用
        _this.tileUnLoad(tile);
      }); // 瓦片数据加载失败
      // eslint-disable-next-line @typescript-eslint/no-unused-vars

      this.tilesetManager.on('tile-error', function (error, tile) {
        // 将事件抛出，图层上可以监听使用
        _this.tileError(error);
      }); // 瓦片显隐状态更新

      this.tilesetManager.on('tile-update', function () {
        _this.tileUpdate();
      }); // 地图视野发生改变

      this.mapService.on('zoomend', function () {
        return _this.viewchange();
      });
      this.mapService.on('moveend', function () {
        return _this.viewchange();
      });
    }
  }, {
    key: "render",
    value: function render() {
      this.tileLayerManager.render();
    } //  防抖操作

  }, {
    key: "tileLoaded",
    value: // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function tileLoaded(tile) {//
    }
  }, {
    key: "tileError",
    value: function tileError(error) {
      console.warn('error:', error);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this$tilesetManager3;

      (_this$tilesetManager3 = this.tilesetManager) === null || _this$tilesetManager3 === void 0 ? void 0 : _this$tilesetManager3.destroy();
      this.tileLayerManager.destroy();
    }
  }, {
    key: "tileUnLoad",
    value: function tileUnLoad(tile) {
      this.tileLayerManager.removeTile(tile);
    }
  }, {
    key: "tileUpdate",
    value: function tileUpdate() {
      var _this2 = this;

      if (!this.tilesetManager) {
        return;
      }

      this.tilesetManager.tiles.filter(function (tile) {
        return tile.isLoaded;
      }).map(function (tile) {
        if (!_this2.isTileReady(tile)) return;

        if (!_this2.tileLayerManager.hasTile(tile)) {
          var _this2$tileLayerManag = _this2.tileLayerManager.addTile(tile),
              layers = _this2$tileLayerManag.layers;

          _this2.setPickState(layers);
        } else {
          if (!tile.isVisibleChange) {
            return;
          }

          var _layers = _this2.tileLayerManager.getChildren(tile.layerIDList);

          updateTileVisible(tile, _layers, _this2.layerService);

          _this2.setPickState(_layers);
        }
      });

      if (this.tilesetManager.isLoaded) {
        // 将事件抛出，图层上可以使用瓦片
        this.parent.emit('tiles-loaded', this.tilesetManager.currentTiles);
      }
    }
  }, {
    key: "isTileReady",
    value: function isTileReady(tile) {
      var _tile$data;

      if ((_tile$data = tile.data) !== null && _tile$data !== void 0 && _tile$data.layers && this.sourceLayer) {
        // vector
        var vectorTileLayer = tile.data.layers[this.sourceLayer];
        var features = vectorTileLayer === null || vectorTileLayer === void 0 ? void 0 : vectorTileLayer.features;

        if (!(Array.isArray(features) && features.length > 0)) {
          return false;
        }
      }

      return true;
    } // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "setPickState",
    value: function setPickState(layers) {}
  }]);

  return Base;
}();